import { useEffect, useState } from 'react'
import { getLoyaltyDiners } from '../api/loyaltyDiners'
import { LoyaltyDiner } from 'api/loyaltyDiners/models'
import { Meta, Link } from 'api/types'

const useLoyaltyDiners = (
  organizationIds: string | string[],
  page: number,
  limit: number
) => {
  const [loyaltyDiners, setLoyaltyDiners] = useState<LoyaltyDiner[]>([])
  const [meta, setMeta] = useState<Meta | null>(null)
  const [links, setLinks] = useState<Link | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchLoyaltyDiners = async () => {
    try {
      setLoading(true)
      const response = await getLoyaltyDiners(organizationIds, page, limit)
      setLoyaltyDiners(response.data)
      setMeta(response.meta ?? null)
      setLinks(response.links ?? null)
    } catch (err: any) {
      setError('Failed to fetch Diners')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (
      organizationIds &&
      (Array.isArray(organizationIds) ? organizationIds.length > 0 : true)
    ) {
      fetchLoyaltyDiners()
    }
    // Dependency stringified to avoid re-renders on new array refs
  }, [JSON.stringify(organizationIds), page, limit])

  return {
    loyaltyDiners,
    meta,
    links,
    loading,
    error,
  }
}

export default useLoyaltyDiners